<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    width="75%"
    top="5vh"
    @close="onClose"
    @open="onOpen"
  >
    <div class="notice-header mb-10">
      <h1>{{ item.Title }}</h1>
      <div class="notice-author">
        <span v-if="item.PublishedUser" style="margin-left:100px;margin-right:100px;">发布人:{{ item.PublishedUser.Name }}</span>
        <span v-if="item.PublishedAt" style="margin-right:100px;">发布日期:{{
          $sys.dateFormat(item.PublishedAt, "Y-m-d")
        }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span v-if="item.Tags" style="margin-right:100px;">标签:
          <el-tag
            v-for="tag in item.Tags"
            :key="tag"
            style="margin-right: 5px; color: #00b3ca"
            >{{ tag }}</el-tag
          >
        </span>
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <!-- <div class="notice-content" v-html="contentHtml"></div> -->
    <div class="markdown-body" v-html="contentHtml"></div>
    <div>
      <div
        v-if="
          item.VideoAddress &&
          item.VideoAddress.length !== 0 &&
          !(item.VideoAddress.length === 1 && item.VideoAddress[0] === '')
        "
        style="padding: 8px; font-size: 12px;font-weight: bold;"
      >
        视频地址:
      </div>
      <div v-for="(url, index) in item.VideoAddress" :key="index">
        <a
          v-if="url!==''"
          target="_blank"
          :href="url"
          style="padding-left: 12px;font-size: 8px; color: #409eff"
          >{{ url }}</a
        >
      </div>
    </div>
    <div>
      <div
        v-if="item.Attachments && item.Attachments.length !== 0"
        style="padding: 8px; font-size: 12px;font-weight: bold;"
      >
        附件:
      </div>
      <div v-for="file in item.Attachments" :key="file.Url">
        <a
            target="_blank"
            :href="file.Url"
            :download="file.Name"
            style="padding-left: 12px;font-size: 8px;color: #409eff"
            >{{ file.Name }}</a
          >
      </div>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-fw fa-times" aria-hidden="true" />关 闭
      </el-button>
    </div>
    <remote-css
      href="https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/2.9.0/github-markdown.min.css"
    ></remote-css>
  </el-dialog>
</template>

<script>
import MavonEditor from "mavon-editor";

export default {
  components: {
    "remote-css": {
      render(createElement) {
        return createElement("link", {
          attrs: { rel: "stylesheet", href: this.href },
        });
      },
      props: {
        href: { type: String, required: true },
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: {},
      // fileList: [],
    };
  },
  computed: {
    contentHtml() {
      return MavonEditor.markdownIt.render(this.item.Content || "");
    },
  },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      //BusinessGroup业务组类型 0.嵌入式 1.工控
      this.$axios
        .get(
          this.item.BusinessGroup === 0
            ? `dci/wiki/${this.item.ID}`
            : `ipc/wiki/${this.item.ID}`
        )
        .then((response) => {
          this.item = response.data;
        });
    
    },
    onClose() {
      this.$emit("update:visible", false);
      // this.fileList = [];
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
  .notice-header {
    text-align: center;
    h1 {
      font-size: 20px;
      margin: 0 0 10px;
    }
    .notice-author {
      color: #888;
      font-size: 8px;
      padding-bottom: 10px;
    }
  }
  .notice-content {
    background: #fff;
    padding: 15px;
    img {
      max-width: 100%;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      th,
      td {
        border: 1px solid #888;
        padding: 3px 5px;
      }
    }
  }
  .el-upload-list__item-status-label {
    position: absolute;
    right: 5px;
    top: 0;
    line-height: inherit;
    display: none;
    visibility: hidden;
  }
  .el-upload-list__item .el-icon-close {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    opacity: 0.75;
    color: #606266;
    visibility: hidden;
  }
  .el-upload-list__item {
    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    font-size: 8px;
    color: #606266;
    line-height: 1.8;
    margin-top: 5px;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
  }
}
</style>
